import { render, staticRenderFns } from "./breadcrumbs.vue?vue&type=template&id=253a1472"
import script from "./breadcrumbs.vue?vue&type=script&lang=js"
export * from "./breadcrumbs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('253a1472')) {
      api.createRecord('253a1472', component.options)
    } else {
      api.reload('253a1472', component.options)
    }
    module.hot.accept("./breadcrumbs.vue?vue&type=template&id=253a1472", function () {
      api.rerender('253a1472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/core/breadcrumbs.vue"
export default component.exports